"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureToggles = exports.portableExperiencesToggles = exports.toggles = void 0;
const validation_1 = require("../../validation");
exports.toggles = ['enabled', 'disabled'];
exports.portableExperiencesToggles = [...exports.toggles, 'hideUi'];
/** @alpha */
var FeatureToggles;
(function (FeatureToggles) {
    FeatureToggles.schema = {
        type: 'object',
        properties: {
            voiceChat: {
                type: 'string',
                enum: exports.toggles,
                nullable: true
            },
            portableExperiences: {
                type: 'string',
                enum: exports.portableExperiencesToggles,
                nullable: true,
                errorMessage: `valid options are ${exports.portableExperiencesToggles.join(', ')}`
            }
        },
        errorMessage: `valid options are ${exports.toggles.join(', ')}`,
        required: []
    };
    FeatureToggles.validate = (0, validation_1.generateLazyValidator)(FeatureToggles.schema);
})(FeatureToggles = exports.FeatureToggles || (exports.FeatureToggles = {}));
//# sourceMappingURL=feature-toggles.js.map